import { ComboBoxItemTypeSOD } from "../components/atoms/ComboBox/ItemComboBoxStrOD"
import { ComboBoxItemTypeS } from "../components/atoms/ComboBox/ItemComboBoxStr"
import { NAME_DEV_SET } from './NameDevSetModel';
import { ResponceDataType } from "../ErrorCode";
import dayjs from 'dayjs';
import i18next from 'i18next';


/**
 * EMCエラーログ情報
 */
export type EMCAlarmLogType = {
  ///収集時刻 を取得または設定します。
  COL_DATE: Date,
  ///異常種別No. を取得又は設定します
  ALM_TYPE_NO: number,
  ///異常区分 1を取得又は設定します。
  ALM_KIND: number,
  ///異常種別名
  TYP_NAME: string,
  //機器番号を取得または設定します。
  DEV_NO: string,
  //機器名称を取得または設定します。
  DEV_NAME: string,
  //PLCNo. を取得または設定します。
  PLC_NO: number,
  //AI カード No. を取得または設定します。
  AI_CARD: number,
  //CHNo. を取得または設定します。
  AI_CH: number,
  //機器 INDEX を取得または設定します。
  DEV_INDEX: number,

  ///連番付与
  rowIndex: number,

}

/**
 * EMC設定情報
 */
export type EMCSettingType = {
  ///PLCNo. を取得または設定します
  /// COL_SET PLC_NO
  PLC_NO: number;
  ///AI カード No. を取得または設定します
  /// COL_SET AI_CARD
  AI_CARD: number;
  /// CHNo. を取得または設定します
  /// COL_SET AI_CH
  AI_CH: number;
  /// 有効フラグを取得または設定します
  /// COL_SET VALID
  VALID: number;
  /// 実行フラグを取得または設定します
  /// COL_SET RUN_FLG
  RUN_FLG: number;
  /// センサー No. を取得または設定します
  /// COL_SET SET_NO
  SET_NO: number;
  /// 機器 INDEX を取得または設定します
  /// NAME_DEV_SET DEV_INDEX
  DEV_INDEX: number;
  ///  機器番号を取得または設定します
  /// NAME_DEV_SET DEV_NO
  DEV_NO: string;
  ///  機器名称を取得または設定します
  /// NAME_DEV_SET DEV_NAME
  DEV_NAME: string;
  ///  電圧(V)を取得または設定します
  /// NAME_DEV_SET VOLTAGE
  VOLTAGE: number;
  ///   定格電流を取得または設定します
  /// NAME_DEV_SET RATED_CUR
  RATED_CUR: number;
  ///  ユニット登録 No. を取得または設定します
  /// COL_SET AI_UNIT
  AI_UNIT: number;
  ///  計測種別 No. を取得または設定します
  /// COL_SET KIND_NO
  KIND_NO: number;
  ///  収集時間を取得または設定します
  /// COL_SET SMP_TIME
  SMP_TIME: number;
  ///  項目名称 No. を取得または設定します
  /// COL_SET ITM_NAME_NO
  ITM_NAME_NO: number;
  ///  ロギング周期を取得または設定します
  /// COL_SET LOG_INT
  LOG_INT: number;
  ///  ロギング開始時刻を取得または設定します
  /// COL_SET LOG_START
  LOG_START?: Date;
  ///  上書フラグを取得または設定します
  /// COL_SET OVERWRITE
  OVERWRITE: number;
  ///  デジタル値 (上限) を取得または設定します
  /// COL_SET DIG_HIGH
  DIG_HIGH: number;
  ///  工学値 (下限) を取得または設定します
  /// COL_SET RL
  RL: number;
  ///  工学値 (上限) を取得または設定します。
  /// COL_SET RH
  RH: number;
  ///  乗率を取得または設定します
  /// COL_SET MUL
  MUL: number;
  ///  単位を取得または設定します
  /// COL_SET UNIT
  UNIT: string;
  ///  リアルタイムトレンド上限値を取得または設定します
  /// COL_SET RT_LMT_H
  RT_LMT_H: number;
  ///  リアルタイムトレンド上上限値を取得または設定します
  /// COL_SET RT_LMT_HH
  RT_LMT_HH: number;
  ///  データ格納 ZR 点数を取得または設定します
  /// COL_SET ZRCH_CNT
  ZRCH_CNT: number;
  ///  メモを取得または設定します
  /// COL_SET MEMO
  MEMO: string;
  ///  モータ起動状態検出フラグを取得または設定します
  /// COL_SET START_DET
  START_DETO: number;
  ///  アベレージ処理方法を取得または設定します
  /// COL_SET AVG_PRC
  AVG_PRC: number;
  ///  エンベロープ後波形保存を取得または設定します
  /// COL_SET ENV_SAV
  ENV_SAV: number;
  ///  回転周波数算出センサーを取得または設定します
  /// COL_SET ROT_CLC
  ROT_CLC: number;
  ///  ユニット No. を取得または設定します
  UnitNo: number;
  ///  局番を取得または設定します
  AreaNo: number;
  ///  有効フラグを取得または設定します
  ValidFlg: boolean;
  ///  実行フラグを取得または設定します
  RunFlg: boolean;

  //インデックス番号付与
  indexNo: number;
  //編集通知
  isEdit: boolean;
};

export const CreateDefalutEMCSettingType = (): EMCSettingType => {
  var ret: EMCSettingType = {
    PLC_NO: 0,
    AI_CARD: 0,
    AI_CH: 0,
    VALID: 0,
    RUN_FLG: 0,
    SET_NO: 0,
    DEV_INDEX: 0,
    DEV_NO: "",
    DEV_NAME: "",
    VOLTAGE: 0,
    RATED_CUR: 0,
    AI_UNIT: 0,
    KIND_NO: 0,
    SMP_TIME: 0,
    ITM_NAME_NO: 0,
    LOG_INT: 0,
    LOG_START: new Date(),
    OVERWRITE: 0,
    DIG_HIGH: 0,
    RL: 0,
    RH: 0,
    MUL: 0,
    UNIT: "",
    RT_LMT_H: 0,
    RT_LMT_HH: 0,
    ZRCH_CNT: 0,
    MEMO: "",
    START_DETO: 0,
    AVG_PRC: 0,
    ENV_SAV: 0,
    ROT_CLC: 0,
    UnitNo: 0,
    AreaNo: 0,
    ValidFlg: false,
    RunFlg: false,
    indexNo: 0,
    isEdit: false,
  };
  return ret;
}

//EMC設定データ取得
export const GetEMCSettings = (): Promise<EMCSettingType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/EMCSetting/")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          //console.error(message);
          reject(message);
        }
        else {
          res.json()
            .then((result: EMCSettingType[]) => {
              //console.debug(["GetEMCSettings - result",result]);
              if (result != null) {
                if (result.length !== 0) {
                  result.map((row, index) => {
                    //連番付与
                    row.indexNo = index + 1;
                  });
                }
                resolve(result);
              }
              reject('Invalidate response');
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            })
        }
      })
  });
};

//EMC設定データ取得（実装データのみ
export const GetEMCSettingsEst = (): Promise<EMCSettingType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/EMCSetting/Est")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          //console.error(message);
          reject(message);
        }
        else {
          res.json()
            .then((result: EMCSettingType[]) => {
              //console.debug(["GetEMCSettings - result",result]);
              if (result != null) {
                if (result.length !== 0) {
                  result.map((row, index) => {
                    //連番付与
                    row.indexNo = index + 1;
                  });
                }
                resolve(result);
              }
              reject('Invalidate response');
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            })
        }
      })
  });
};

/**
 *EMC設定データ更新
 * @returns
 */
export const PutEMCSettings = (settings: EMCSettingType[]): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    let updateRows = settings.filter((r) => r.isEdit == true);
    console.debug(["PutEMCSettings - settings updateRows", settings, updateRows]);
    fetch("api/EMCSetting/", {
      method: "put",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateRows)
    }).then((res) => {
      if (!res.ok) {
        let message = `データが見つかりませんでした status:${res.status}`;
        reject(message);
      }
      return res.json();
    }).then((result: ResponceDataType) => {
      console.debug(["PutEMCSettings - result ", result])
      resolve(result);
    },
      (error) => {
        console.error(error);
        reject(error);
      })
  });
}


/**
 * EMCアラームデータ取得
 * @returns
 */
export const GetEMCAlarmLogs = (): Promise<EMCAlarmLogType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/EMCTrend/EMCAlarmLogs")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          //console.error(message);
          reject(message);
        }
        else {
          res.json()
            .then((result: EMCAlarmLogType[]) => {
              console.debug(["GetEMCAlarmLogss - result", result]);
              if (result != null) {
                //連番付与
                result.forEach((r, index) => r.rowIndex = (index + 1));
                resolve(result);
              }
              else {
                reject('Invalidate response');
              }
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            })
        }
      })
  });
};


/**
 *　設定画面で使用するコンボボックスアイテムリストを作成
 * @param settings EMC設定データリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateSettingCombBoxItems = (settings: EMCSettingType[], nameDevSets: NAME_DEV_SET[], translation: any): ComboBoxItemTypeSOD[] => {

  let comboItems: ComboBoxItemTypeSOD[] = [];

  //空白を追加
  comboItems.push({ key: "0", name: "-" });

  nameDevSets.forEach((r) => {
    let item: ComboBoxItemTypeSOD = {
      key: r.DEV_INDEX.toString(),
      name: `${r.DEV_NO} ${r.DEV_NAME}`
    }
    comboItems.push(item);
  });

  let msg = i18next.t('EMCSetting.未実装', '(未実装)');
  //未実装を追加
  settings.forEach((r) => {
    if (r.DEV_INDEX !== null &&
      r.DEV_INDEX !== 0
      && nameDevSets.findIndex((rr) => rr.DEV_INDEX === r.DEV_INDEX) === -1) {
      comboItems.push({ key: r.DEV_INDEX.toString(), name: `${msg} [${r.DEV_NO} ${r.DEV_NAME}]` });
    }
    return;
  });
  return comboItems;
};

/**
 *　選択画面で使用するコンボボックスアイテムリストを作成
 * @param settings EMC設定データリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateSelectCombBoxItems = (settings: EMCSettingType[]): ComboBoxItemTypeS[] => {

  let comboItems: ComboBoxItemTypeS[] = [];
  const selectDt = settings.filter((r) => r.DEV_INDEX != 0);
  selectDt.forEach((r) => {
    let item: ComboBoxItemTypeS = {
      key: r.DEV_INDEX.toString(),
      name: `${r.DEV_NO} ${r.DEV_NAME}`
    }
    comboItems.push(item);
  });

  return comboItems;
};

/**
 *　選択画面で使用するアラームの日付リストを作成
 * @param settings EMC設定データリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateSelectAlarmItems = (devIndex: number, alarmLogList: EMCAlarmLogType[]): string[] => {

  let alramList: string[] = [];
  let setAlarmList = alarmLogList.filter((r) => r.DEV_INDEX === devIndex);
  setAlarmList.forEach((r) => {
    alramList.push(dayjs(r.COL_DATE).format('YYYY-MM-DD'));
  });
  //重複を削除
  alramList = alramList.filter((x, i, self) => self.indexOf(x) === i);

  return alramList;
};

/**
 *　選択画面で使用するアラームの日付コンボボックスデータを作成
 * @param settings EMC設定データリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateSelectAlarmCombBoxItems = (devIndex: number, alarmLogList: EMCAlarmLogType[]): ComboBoxItemTypeS[] => {

  var logs = CreateSelectAlarmItems(devIndex, alarmLogList);
  let alramComboBox: ComboBoxItemTypeS[] = [];
  logs.forEach((r) => {
    let item: ComboBoxItemTypeS = {
      key: dayjs(r).format('YYYYMMDD'),
      name: dayjs(r).format('YYYY-MM-DD')
    }
    alramComboBox.push(item);
  });
  return alramComboBox;
};
/**
 *　選択画面で使用するアラームの日付データ作成
 * @param settings EMC設定データリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateSelectAlarmLogList = (devIndex: number, alarmLogList: EMCAlarmLogType[]): EMCAlarmLogType[] => {
  let alramLogList: EMCAlarmLogType[] = []
  alramLogList = alarmLogList.filter((r) => r.DEV_INDEX === devIndex);
  return alramLogList;
};


/**
 *編集フラグがOnになっているかを確認
 * @param settings EMC設定配列
 * @returns
 */
export const CheckEMCSettingEditFlg = (settings: EMCSettingType[]): boolean => {
  if (settings == null || settings.length == 0) {
    return false;
  }
  if (settings.findIndex((r) => r.isEdit == true) == -1) {
    return false;
  }
  return true;
};


/**
 * 入力値チェック
 * @param setting
 */
export const CheckInputData = (setting: EMCSettingType[], translation: any): string[] => {
  let message: string[] = [];

  //DEVINDEXの重複チェック
  let cRow = setting.filter((r) => r.DEV_INDEX > 0);

  cRow.forEach((r, index) => {
    let f = cRow.findIndex((rr) => rr.DEV_INDEX === r.DEV_INDEX);
    if (f !== index) {
      console.debug(["CheckInputData - error ", r]);
      message.push(`${r.indexNo} ` + i18next.t('messages.重複エラー', 'INDEX_NO 重複エラー'));
    }
  });
  return message;
};
